export default __webpack_public_path__ + "static/8-f5daa808ec2d03bc69596bfebacdd573.webp";